export const mergeListByKey = (defaultList, list, key = 'prop') => {
  // 合并默认按钮属性
  list.forEach((item) => {
    const defaultIndex = defaultList.findIndex(
      (item1) => item1[key] === item[key],
    )
    if (defaultIndex !== -1) {
      defaultList[defaultIndex] = {
        ...defaultList[defaultIndex],
        ...item,
      }
    }
  })
  const allList = defaultList.concat(list!)
  const mergeList = allList.reduce((arr, item) => {
    if (!Reflect.has(item, key) || !arr.some((obj) => obj[key] === item[key])) {
      arr.push(item)
    }
    return arr
  }, [])
  return mergeList
}

export function bindMethods<T extends object>(instance: T): void {
  const prototype = Object.getPrototypeOf(instance)
  const propertyNames = Object.getOwnPropertyNames(prototype)

  propertyNames.forEach((propertyName) => {
    const descriptor = Object.getOwnPropertyDescriptor(prototype, propertyName)
    const propertyValue = instance[propertyName as keyof T]

    if (
      typeof propertyValue === 'function' &&
      propertyName !== 'constructor' &&
      descriptor &&
      !descriptor.get &&
      !descriptor.set
    ) {
      instance[propertyName as keyof T] = propertyValue.bind(instance)
    }
  })
}
